// A record number in the identifier pill, short form ("CN-0007" for
// "CN-2026-0007"), with the full number on hover. Same look as the Lot No
// / Code pills (see CLAUDE.md: Identifier pill).

import { shortInvoiceNo } from '../utils/invoiceNo';

export function ShortNoPill({ value }: { value?: string }) {
  if (!value) return <span style={{ opacity: 0.4 }}>—</span>;
  return (
    <span title={value} style={{
      display: 'inline-block', fontFamily: 'var(--font-num)', background: 'var(--primary-light)',
      color: 'var(--primary)', fontSize: 11, fontWeight: 700, padding: '3px 8px',
      borderRadius: 6, letterSpacing: '0.02em', whiteSpace: 'nowrap',
    }}>{shortInvoiceNo(value)}</span>
  );
}
